import {IButton, IKnockoutComponent, TBaseOrObservableType} from "../../../index";
import {ButtonManager} from "../../../util/ButtonManager";
import {getAnyValue, isKnockoutCompoonent} from "../../../util/misc";
import pageHtml from './page.html?raw';

export let template = pageHtml;

interface IParams {
    buttons?: KnockoutObservableArray<IButton> | IButton[]
    buttonManager?: ButtonManager
}

export class viewModel {
    private buttonManager: ButtonManager;
    constructor(params: IParams) {
        if (params.buttonManager) {
            this.buttonManager = params.buttonManager;
        } else {
            this.buttonManager = new ButtonManager(params.buttons)
        }
    }

    private isComponent = isKnockoutCompoonent
}
